import { trackEvent } from "@ip-utils";

import Button from "./Button";
import ButtonWithLoadingIcon from "./ButtonWithLoadingIcon";
import CircularButton from "./CircularButton";
import FullWidthButton from "./FullWidthButton";
import NoBorderButtonWithPlusIcon from "./NoBorderButtonWithPlusIcon";
import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";
import SecondaryButtonWithLoadingIcon from "./SecondaryButtonWithLoadingIcon";
import SubmitButton from "./SubmitButton";
import WhiteButton from "./WhiteButton";
import WhiteButtonWithBorder from "./WhiteButtonWithBorder";

export const handleTrackingButtonOnClick = (text: string, onClick: any) => {
  const category = "Button";
  const action = `Click '${text}'`;

  trackEvent(category, action);
  onClick();
};

export {
  Button,
  PrimaryButton,
  SecondaryButton,
  SecondaryButtonWithLoadingIcon,
  FullWidthButton,
  WhiteButton,
  CircularButton,
  NoBorderButtonWithPlusIcon,
  ButtonWithLoadingIcon,
  SubmitButton,
  WhiteButtonWithBorder,
};
